import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const MONTH_ABBR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

const COUNTRY_TIMEZONE_MAP: Record<string, string> = {
  CN: 'Asia/Shanghai',
  HK: 'Asia/Hong_Kong',
  MO: 'Asia/Macau',
  TW: 'Asia/Taipei',
  UK: 'Europe/London',
  DE: 'Europe/Berlin',
  FR: 'Europe/Paris',
  NL: 'Europe/Amsterdam',
  NO: 'Europe/Oslo',
  DK: 'Europe/Copenhagen',
  SE: 'Europe/Stockholm',
  CH: 'Europe/Zurich',
  AT: 'Europe/Vienna',
  IT: 'Europe/Rome',
  ES: 'Europe/Madrid',
  BE: 'Europe/Brussels',
  IE: 'Europe/Dublin',
  MY: 'Asia/Kuala_Lumpur',
  SG: 'Asia/Singapore',
  TH: 'Asia/Bangkok',
  ID: 'Asia/Jakarta',
  PH: 'Asia/Manila',
  VN: 'Asia/Ho_Chi_Minh',
  AE: 'Asia/Dubai',
  IL: 'Asia/Jerusalem',
  AU: 'Australia/Sydney',
  NZ: 'Pacific/Auckland'
};

/**
 * 后端 publishTime / topTime 已是 UTC 毫秒时间戳。
 * 国内(CN)按北京时区展示；其它国家按对应时区展示，未匹配到时兜底走 UTC(0 时区)。
 * 输出格式：`12 Jun,2026 14:40:35`
 */
export function formatNoticeTime(ts: number | null | undefined, countryCode: string): string {
  if (ts === null || ts === undefined) return '';
  const tz = COUNTRY_TIMEZONE_MAP[countryCode] ?? 'UTC';
  const target = dayjs(ts).tz(tz);
  const day = String(target.date()).padStart(2, '0');
  const month = MONTH_ABBR[target.month()];
  const year = target.year();
  const hh = String(target.hour()).padStart(2, '0');
  const mm = String(target.minute()).padStart(2, '0');
  const ss = String(target.second()).padStart(2, '0');
  return `${day} ${month},${year} ${hh}:${mm}:${ss}`;
}
